"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferNotificationSubscriptionForm = OfferNotificationSubscriptionForm;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const account_context_1 = require("@src/context/account-context");
const convert_selected_locations_1 = require("@src/helpers/convert-selected-locations");
const offer_filter_context_1 = require("@src/components/pages/offers/offer-filter-context");
const specific_search_select_field_1 = require("@src/components/modules/forms/specific-search-select-field");
const offer_notification_subscription_validation_rules_1 = require("./offer-notification-subscription-validation-rules");
const LocationSelect_1 = require("./LocationSelect");
const job_area_select_field_1 = require("../job-area-select-field");
const typeSelectFields_1 = require("../type-select-field/typeSelectFields");
const salaryRangeField_1 = require("../salary-range-field/salaryRangeField");
const OfferNotificationSubscriptionForm_styles_1 = require("./OfferNotificationSubscriptionForm.styles");
function getOfferNotificationApiErrorCode(err) {
    var _a;
    if (typeof err === 'object' && err !== null && 'response' in err) {
        const data = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data;
        return data === null || data === void 0 ? void 0 : data.code;
    }
    return undefined;
}
function OfferNotificationSubscriptionForm({ subscription, onSubmit, showEmailField, onDelete, }) {
    const [formAction, setFormAction] = react_1.default.useState(types_1.OnsFormAction.CREATE);
    const [isSubmitting, setIsSubmitting] = react_1.default.useState(false);
    const [form] = antd_1.Form.useForm();
    const account = (0, account_context_1.useAccount)();
    const [formValues, setFormValues] = react_1.default.useState(form.getFieldsValue());
    const history = (0, react_router_dom_1.useHistory)();
    const intl = (0, react_intl_1.useIntl)();
    react_1.default.useEffect(() => {
        setFormAction((subscription === null || subscription === void 0 ? void 0 : subscription.id) ? types_1.OnsFormAction.UPDATE : types_1.OnsFormAction.CREATE);
    }, [subscription]);
    const subscriptionToken = history.getQuery().onst;
    const { emailValidationRules, subscriptionFilterRules, salaryMaxValidationRules } = (0, offer_notification_subscription_validation_rules_1.getValidationRules)({
        intl,
        subscriptionToken,
        formValues,
    });
    const showSuccessNotification = (action) => {
        let message = intl.formatMessage({
            id: 'forms.offer_notification_subscription_form.data_successfully_changed',
        });
        if (action === types_1.OnsFormAction.CREATE) {
            message = intl.formatMessage({
                id: 'forms.offer_notification_subscription_form.subscription_created',
            });
        }
        if (action === types_1.OnsFormAction.DELETE) {
            message = intl.formatMessage({
                id: 'forms.offer_notification_subscription_form.subscription_deleted',
            });
        }
        antd_1.notification.success({
            message: intl.formatMessage({
                id: 'forms.offer_notification_subscription_form.notification',
            }),
            description: message,
        });
    };
    const showErrorNotification = () => {
        antd_1.notification.error({
            message: intl.formatMessage({
                id: 'forms.offer_notification_subscription_form.error',
            }),
            description: intl.formatMessage({
                id: 'forms.offer_notification_subscription_form.something_went_wrong',
            }),
        });
    };
    const showSubmitErrorNotification = (err) => {
        const code = getOfferNotificationApiErrorCode(err);
        if (code === types_1.OFFER_NOTIFICATION_API_ERROR_CODES.REGISTERED_ACCOUNT) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.error',
                }),
                description: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.account_exists_log_in_to_manage',
                }),
            });
            return;
        }
        if (code === types_1.OFFER_NOTIFICATION_API_ERROR_CODES.EMAIL_ALREADY_SUBSCRIBED) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.error',
                }),
                description: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.email_already_subscribed_guest',
                }),
            });
            return;
        }
        showErrorNotification();
    };
    const submitForm = async (formData) => {
        setIsSubmitting(true);
        try {
            const subscriptionData = {
                ...formData,
                selectedLocations: (0, convert_selected_locations_1.convertSelectedLocations)(formData.selectedLocations),
                specificSearch: formValues.specificSearch,
            };
            if (!formData.email) {
                subscriptionData.email = ((subscription === null || subscription === void 0 ? void 0 : subscription.email) || (account === null || account === void 0 ? void 0 : account.email));
            }
            if (formAction === types_1.OnsFormAction.CREATE) {
                await Api.OfferNotificationSubscription.createSubscription(subscriptionData);
            }
            else {
                await Api.OfferNotificationSubscription.updateSubscription(subscriptionData, subscription.token);
            }
            showSuccessNotification(formAction);
            onSubmit();
        }
        catch (err) {
            showSubmitErrorNotification(err);
        }
        finally {
            setIsSubmitting(false);
        }
    };
    const handleDelete = async () => {
        try {
            await Api.OfferNotificationSubscription.deleteSubscription(subscription.token);
            showSuccessNotification(types_1.OnsFormAction.DELETE);
            if (onDelete) {
                onDelete();
            }
        }
        catch (err) {
            showErrorNotification();
        }
    };
    const { jobAreaFiltersSelected, locationFiltersSelected, typeFiltersSelected, salaryFilter, searchKeywordsSelected, searchCompaniesSelected, } = (0, offer_filter_context_1.useOffersFilterContextValue)();
    const initialValues = {
        email: (subscription === null || subscription === void 0 ? void 0 : subscription.email) || (account === null || account === void 0 ? void 0 : account.email) || '',
        jobAreaIds: (subscription === null || subscription === void 0 ? void 0 : subscription.jobAreaIds) || jobAreaFiltersSelected || [],
        selectedLocations: (subscription === null || subscription === void 0 ? void 0 : subscription.locationIds) || locationFiltersSelected || [],
        typeIds: (subscription === null || subscription === void 0 ? void 0 : subscription.typeIds) || typeFiltersSelected || [],
        salaryRate: (subscription === null || subscription === void 0 ? void 0 : subscription.salaryRate) || salaryFilter.rate || undefined,
        salaryMin: (subscription === null || subscription === void 0 ? void 0 : subscription.salaryMin) || salaryFilter.minRange,
        salaryMax: (subscription === null || subscription === void 0 ? void 0 : subscription.salaryMax) || salaryFilter.maxRange,
    };
    if ((subscription === null || subscription === void 0 ? void 0 : subscription.is_remote) && !initialValues.selectedLocations.includes(types_1.REMOTE)) {
        initialValues.selectedLocations.push(types_1.REMOTE);
    }
    if ((subscription === null || subscription === void 0 ? void 0 : subscription.is_abroad) && !initialValues.selectedLocations.includes(types_1.ABROAD)) {
        initialValues.selectedLocations.push(types_1.ABROAD);
    }
    const specificSearch = (0, offer_filter_context_1.formatCombinedValues)({
        companies: (subscription === null || subscription === void 0 ? void 0 : subscription.companies) || searchCompaniesSelected || [],
        keywords: (subscription === null || subscription === void 0 ? void 0 : subscription.keywords) || searchKeywordsSelected || [],
        skillTags: (subscription === null || subscription === void 0 ? void 0 : subscription.skillTags) || [],
    });
    initialValues.specificSearch = specificSearch;
    react_1.default.useEffect(() => {
        form.setFieldsValue(initialValues);
        setFormValues(initialValues);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(antd_1.Form, { layout: "vertical", onFinish: submitForm, form: form, onValuesChange: values => setFormValues({ ...formValues, ...values }), children: [showEmailField && ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: (0, jsx_runtime_1.jsx)("div", { className: "flex-row", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "forms.offer_notification_subscription_form.email" }) }), rules: emailValidationRules, name: "email", children: (0, jsx_runtime_1.jsx)(OfferNotificationSubscriptionForm_styles_1.EmailInput, { placeholder: intl.formatMessage({ id: 'global.email.placeholder' }), type: "email" }) })), (0, jsx_runtime_1.jsx)(elements_1.Title, { className: "text-left font-normal m-b-m m-t-m", level: 5, children: intl.formatMessage({ id: 'offers.offer_notification_subscription_form.criteria' }) }), (0, jsx_runtime_1.jsx)(typeSelectFields_1.TypeSelectField, { label: intl.formatMessage({ id: 'forms.offer_notification_subscription_form.type' }), name: "typeIds", rules: subscriptionFilterRules }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.location',
                }), name: "selectedLocations", rules: subscriptionFilterRules, children: (0, jsx_runtime_1.jsx)(LocationSelect_1.LocationSelect, { placeholder: intl.formatMessage({ id: 'global.location.placeholder' }) }) }), (0, jsx_runtime_1.jsx)(job_area_select_field_1.JobAreaSelectField, { label: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.job_area',
                }), name: "jobAreaIds", rules: subscriptionFilterRules }), (0, jsx_runtime_1.jsx)(specific_search_select_field_1.SpecificSearchSelectField, { name: "specificSearch", rules: subscriptionFilterRules, formValues: formValues, setFormValues: setFormValues }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(salaryRangeField_1.SalaryRangeField, { form: form, maxRules: salaryMaxValidationRules, rateRules: subscriptionFilterRules }) }), formAction === types_1.OnsFormAction.UPDATE && ((0, jsx_runtime_1.jsx)("div", { className: "flex-center m-b-l", children: (0, jsx_runtime_1.jsx)(OfferNotificationSubscriptionForm_styles_1.CancelSubscriptionButton, { type: "button", onClick: handleDelete, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "forms.offer_notification_subscription_form.cancel_subscription" }) }) })), (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", htmlType: "submit", loading: isSubmitting, children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-xxs", children: formAction === types_1.OnsFormAction.CREATE ? ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "forms.offer_notification_subscription_form.subscribe" })) : ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "forms.offer_notification_subscription_form.save_changes" })) }) }) }), (0, jsx_runtime_1.jsxs)(OfferNotificationSubscriptionForm_styles_1.RequiredWrapper, { children: [(0, jsx_runtime_1.jsx)(OfferNotificationSubscriptionForm_styles_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.required_fields" })] })] }));
}
